import {PropsWithChildren} from 'react'

type Props = {
    width: number | string
}

const ComponentDivWidth = ({ width, children } :PropsWithChildren<Props>) =>
    <div style={{width: (typeof width === 'string') ? width : `${width}px`}}>{ children }</div>

export default ComponentDivWidth